(function() {
  'use strict';

  function initSlider(section) {
    const track = section.querySelector('[data-bigmad-vslider-track]');
    if (!track) return;

    const items = track.querySelectorAll('.bigmad-vslider-item');
    if (items.length === 0) return;

    // Centraliza no item do meio na primeira carga
    const mid = Math.floor(items.length / 2);
    const target = items[mid];
    setTimeout(() => {
      const offset = target.offsetLeft - (track.offsetWidth / 2) + (target.offsetWidth / 2);
      track.scrollTo({ left: offset, behavior: 'instant' });
    }, 100);

    // Drag-to-scroll com mouse (desktop)
    let isDown = false;
    let startX = 0;
    let scrollLeftStart = 0;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeftStart = track.scrollLeft;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
    });

    const stopDrag = () => {
      if (!isDown) return;
      isDown = false;
      track.style.scrollSnapType = 'x mandatory';
      track.style.scrollBehavior = 'smooth';
    };

    track.addEventListener('mouseleave', stopDrag);
    track.addEventListener('mouseup', stopDrag);

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 2;
      track.scrollLeft = scrollLeftStart - walk;
    });
  }

  function init() {
    const sections = document.querySelectorAll('[data-bigmad-vslider]');
    sections.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init no theme editor do Shopify
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-bigmad-vslider]');
    if (section) initSlider(section);
  });
})();